document.addEventListener('DOMContentLoaded', function () {
  let self;
  let popupManager = {};

  popupManager = {
    sPrevious: window.scrollY,
    sDirection: 'down',

    init() {
      self = popupManager;
      self.popupInit();
      self.events();
    },

    events() {
      // CLICK EVENTS
      document.addEventListener('click', function (e) {
        const target = e.target;

        if (target.matches('.popup-close') || target.closest('.popup-close')) {
          self.closePopup(e);
        }

        if (target.matches('.popup-accept')) {
          self.acceptPopup(e);
          self.closePopup(e);
        }

        if (target.matches('.age-verification__popup-close')) {
          self.agePopup(e);
          self.closePopup(e);
        }

        if (target.matches('.age-verification__button-no')) {
          self.ageDeclined(e);
        }
      });

      // KEY EVENTS
      document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('.popup-open[data-esc-close="true"]').forEach(function (item) {
            self.closePopup(item);
          });
        }

        if (e.key === 'F4') {
          document.querySelectorAll('.popup-open[data-f4-close="true"]').forEach(function (item) {
            self.closePopup(item);
          });
        }
      });

      // OVERLAY CLICK
      document.querySelectorAll('.popup-overlay').forEach((overlay) => {
        overlay.addEventListener('click', () => {
          const popup = overlay.previousElementSibling;

          if (popup.matches('.popup-open[data-overlay-close="true"]')) {
            self.closePopup(popup);
          }
        });
      });
    },

    popupInit() {
      // Scroll direction detector
      document.addEventListener('scroll', function () {
        const currentY = window.scrollY;
        popupManager.sDirection = currentY > popupManager.sPrevious ? 'down' : 'up';
        popupManager.sPrevious = currentY;
      });

      // Init all popups
      document.querySelectorAll('.popup').forEach((popup) => {
        const triggers = (popup.getAttribute('data-open-trigger') || '')
          .split(',')
          .map((t) => t.trim())
          .filter(Boolean);

        // Manual trigger
        if (triggers.includes('manual')) {
          const selector = popup.getAttribute('data-open-manual-selector');

          if (selector) {
            const element =
              selector.charAt(0) === '#'
                ? document.getElementById(selector.slice(1))
                : document.querySelector(selector);

            if (element) {
              element.classList.add('popup-trigger');

              element.addEventListener('click', (e) => {
                e.preventDefault();

                popup.classList.remove('popup-already-opened');
                self.openPopup(popup);

                if (e.target.classList.contains('popup')) {
                  self.closePopup(popup);
                }
              });
            }
          }
        }

        // Auto trigger
        if (self.isAllowPopup(popup) || popup.classList.contains('age-verification')) {
          self.openTriggerPopup(popup);
        }
      });
    },

    openTriggerPopup(popup) {
      const triggers = (popup.getAttribute('data-open-trigger') || '')
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean);

      // open instantly if needed
      if (!triggers.includes('none') || !self.getCookie('popup-age-' + (popup.getAttribute('data-id') || 0))) {
        if (triggers.includes('none')) {
          self.openPopup(popup);
        }
      }

      // Delay
      if (triggers.includes('delay')) {
        const delay = parseInt(popup.getAttribute('data-open-delay-number'));
        setTimeout(() => self.openPopup(popup), delay * 1000);
      }

      // Exit intent
      if (triggers.includes('exit')) {
        let active = true;

        document.addEventListener('mousemove', function (e) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (e.pageY - scrollTop < 7 && active) {
            self.openPopup(popup);
            active = false;
          }
        });
      }

      // Scroll
      if (triggers.includes('scroll')) {
        const type = popup.getAttribute('data-open-scroll-type');
        const position = popup.getAttribute('data-open-scroll-position');

        document.addEventListener('scroll', function () {
          if (type === 'px' && window.scrollY >= position) {
            self.openPopup(popup);
          }
          if (type === '%' && self.getScrollPercent() >= position) {
            self.openPopup(popup);
          }
        });
      }

      // Accept once
      if (triggers.includes('accept') && !self.getCookie('popup-accept-' + (popup.getAttribute('data-id') || 0))) {
        self.openPopup(popup);
      }
    },

    closeTriggerPopup(popup) {
      const trigger = popup.getAttribute('data-close-trigger');
      // Delayed close
      if (trigger === 'delay') {
        const delay = parseInt(popup.getAttribute('data-close-delay-number'));
        setTimeout(() => self.closePopup(popup), delay * 1000);
      }
      // Scroll close
      if (trigger === 'scroll') {
        const type = popup.getAttribute('data-close-scroll-type');
        const pos = popup.getAttribute('data-close-scroll-position');
        const initPx = popup.getAttribute('data-init-scroll-px');
        const initPercent = popup.getAttribute('data-init-scroll-percent');
        document.addEventListener('scroll', function () {
          const dir = popupManager.sDirection;
          if (type === 'px') {
            if (dir === 'up' && window.scrollY < initPx - pos) {
              self.closePopup(popup);
            }
            if (dir === 'down' && window.scrollY >= parseInt(initPx) + parseInt(pos)) {
              self.closePopup(popup);
            }
          }
          if (type === '%') {
            const percent = self.getScrollPercent();
            if (dir === 'up' && percent < initPercent - pos) {
              self.closePopup(popup);
            }
            if (dir === 'down' && percent >= parseInt(initPercent) + parseInt(pos)) {
              self.closePopup(popup);
            }
          }
        });
      }
    },

    openPopup(popup) {
      if (popup.classList.contains('popup-already-opened') || popup.classList.contains('popup-open')) return;

      // Disable body scroll
      if (popup.getAttribute('data-body-scroll-disable') === 'true') {
        document.body.classList.add('popup-scroll-hidden');

        if (popup.getAttribute('data-mobile-disable') === 'false') {
          document.body.classList.add('popup-scroll-hidden-mobile');
        }
      }

      // Cookie count
      let openedCount = parseInt(self.getCookie('popup-' + popup.getAttribute('data-id')) || 0) + 1;
      self.setCookie('popup-' + popup.getAttribute('data-id'), openedCount, {
        expires: popup.getAttribute('data-limit-lifetime'),
      });

      // Open popup
      popup.classList.add('popup-open');
      popup.setAttribute('data-init-scroll-px', window.scrollY);
      popup.setAttribute('data-init-scroll-percent', self.getScrollPercent());

      const animation = popup.getAttribute('data-open-animation');
      self.applyAnimation(popup, animation);

      self.closeTriggerPopup(popup);
    },

    agePopup(e) {
      const popup = (e.target || e).closest('.popup');
      self.setCookie('popup-age-' + popup.getAttribute('data-id'), 1, { expires: 360 });
    },

    ageDeclined() {
      document.querySelectorAll('.age-verification__question').forEach((x) => {
        x.classList.remove('show');
      });

      document.querySelector('.age-verification__declined').classList.add('show');
    },

    acceptPopup(e) {
      const popup = (e.target || e).closest('.popup');
      self.setCookie('popup-accept-' + popup.getAttribute('data-id'), 1, { expires: 360 });
    },

    closePopup(e) {
      const popup = (e.target || e).closest('.popup');
      const anim = popup.getAttribute('data-exit-animation');

      self.applyAnimation(popup, anim, function () {
        popup.classList.add('popup-already-opened');
        popup.classList.remove('popup-open');
      });

      document.body.classList.remove('popup-scroll-hidden');
      document.body.classList.remove('popup-scroll-hidden-mobile');
    },

    isAllowPopup(popup) {
      const limit = parseInt(popup.getAttribute('data-limit-display') || 0);
      const opened = parseInt(self.getCookie('popup-' + popup.getAttribute('data-id')));

      return !(limit && opened && limit <= opened);
    },

    applyAnimation(popup, animation, callback) {
      const p = popup.closest('.popup');
      const type = typeof callback === 'function' ? 'popupExitFade' : 'popupOpenFade';

      // Overlay animation
      if (p.nextElementSibling) {
        const overlay = p.nextElementSibling;
        overlay.classList.add('popup-animated', type);

        overlay.addEventListener(
          'animationend',
          function () {
            overlay.classList.remove('popup-animated', type);
          },
          { once: true }
        );
      }

      // Popup animation
      const wrap = p.querySelector('.popup-wrap');
      wrap.classList.add('popup-animated', animation);

      wrap.addEventListener(
        'animationend',
        function () {
          wrap.classList.remove('popup-animated', animation);
          if (typeof callback === 'function') callback();
        },
        { once: true }
      );
    },

    getCookie(name) {
      const match = document.cookie.match(
        new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)')
      );
      return match ? decodeURIComponent(match[1]) : undefined;
    },

    setCookie(name, value, options = {}) {
      options.path = options.path || '/';
      options.expires = parseInt(options.expires);

      if (typeof options.expires === 'number' && options.expires) {
        const date = new Date();
        date.setDate(date.getDate() + options.expires);
        options.expires = date.toUTCString();
      }

      let updatedCookie = name + '=' + encodeURIComponent(value);

      for (const optionKey in options) {
        updatedCookie += '; ' + optionKey;
        const optionValue = options[optionKey];
        if (optionValue !== true) updatedCookie += '=' + optionValue;
      }

      document.cookie = updatedCookie;
    },

    getScrollPercent() {
      const doc = document.documentElement;
      const body = document.body;
      const scrollTop = doc.scrollTop || body.scrollTop;
      const scrollHeight = doc.scrollHeight || body.scrollHeight;

      return (scrollTop / (scrollHeight - doc.clientHeight)) * 100;
    },
  };

  popupManager.init();

  // Shopify Section Reload Events
  document.addEventListener('shopify:section:load', function () {
    popupManager.init();
  });

  document.addEventListener('shopify:section:unload', function () {
    document.body.classList.remove('popup-scroll-hidden');
  });
});
